<input
    class="form-control [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
    type="number"
    bigSharedTrimOnBlur
    [id]="id"
    [name]="id"
    [required]="isRequired"
    [placeholder]="placeholder"
    (blur)="onBlur()"
    (ngModelChange)="onChange(formControl.value)"
    [formControl]="formControl"
    [ngClass]="{
        'is-invalid': !isValid && showValidation,
        'is-valid': isValid && showValidation,
    }" />
<ng-content />
